import firebase from "firebase/app";
import "firebase/auth";
import "firebase/messaging";

// uora.italia@gmail.com
// )7gh8qLmMzzNNs.

// "email" : "macro.mazzagreco@gmail.com",
// "password" : "macro@591985"

const firebaseConfig = {
  apiKey: "AIzaSyBrW9QxIEz-SCp4QeK4sTgG0qmvA1OI5O4",
  authDomain: "uora-8da17.firebaseapp.com",
  projectId: "uora-8da17",
  storageBucket: "uora-8da17.appspot.com",
  messagingSenderId: "269351439150",
  appId: "1:269351439150:web:c213b88839db605553c8bf",
  measurementId: "G-LC5Y6PXQK5"
};

firebase.initializeApp(firebaseConfig);
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { firebase, googleAuthProvider};

// const messaging = firebase.messaging();

// messaging.onMessage((payload) => {
//   console.log("Message received. ", payload);
// });

// const getToken = (setTokenFound) => {
//   return messaging
//     .getToken({ vapidKey: "GENERATED_MESSAGING_KEY" })
//     .then((currentToken) => {
//       if (currentToken) {
//         console.log("current token for client: ", currentToken);
//         setTokenFound(true);
//         // Track the token -> client mapping, by sending to backend server
//         // show on the UI that permission is secured
//       } else {
//         console.log(
//           "No registration token available. Request permission to generate one."
//         );
//         setTokenFound(false);
//         // shows on the UI that permission is required
//       }
//     })
//     .catch((err) => {
//       console.log("An error occurred while retrieving token. ", err);
//       // catch error while creating client token
//     });
// };


// apiKey: "AIzaSyALsMzX-uu70JhPXvueO6w66SZ-FD670JI",
// authDomain: "uora-8fda7.firebaseapp.com",
// projectId: "uora-8fda7",
// storageBucket: "uora-8fda7.appspot.com",
// messagingSenderId: "902069242642",
// appId: "1:902069242642:web:494862ff979db67a8801cb",
// measurementId: "G-RRQTVYXY0V",
